// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-music-button {
  position: fixed;
  right: 20px;
  bottom: 90px; /* Position above Chester button */
  width: 60px;
  height: 60px;
  background-color: #df2d11;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  z-index: 1002;
  box-sizing: border-box;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;
  color: white;
}

.bg-music-button:hover {
  transform: scale(1.05);
}

.bg-music-button svg {
  width: 30px;
  height: 30px;
  color: #fff !important;
}

@media (max-width: 576px) {
  .bg-music-button {
    right: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BackgroundMusic.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY,EAAE,kCAAkC;EAChD,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".bg-music-button {\n  position: fixed;\n  right: 20px;\n  bottom: 90px; /* Position above Chester button */\n  width: 60px;\n  height: 60px;\n  background-color: #df2d11;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  z-index: 1002;\n  box-sizing: border-box;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease;\n  color: white;\n}\n\n.bg-music-button:hover {\n  transform: scale(1.05);\n}\n\n.bg-music-button svg {\n  width: 30px;\n  height: 30px;\n  color: #fff !important;\n}\n\n@media (max-width: 576px) {\n  .bg-music-button {\n    right: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
